$('#hidden').on('change', function () {
  const is_checked = $('#hidden').prop('checked')
  if (is_checked) {
    console.log(is_checked)
    $('#hidden-value').val('is_hidden')
  } else {
    console.log(is_checked)
    $('#hidden-value').val(null)
  }
})
